const countyOptions = [
	"",
	"Alachua",
	"Baker",
	"Bay",
	"Bradford",
	"Broward",
    "Brevard",
	"Calhoun",
    "Charlotte",
	"Cirtus",
	"Clay",
	"Collier",
    "Columbia",
    "DeSoto",
	"Dixie",
	"Duval",
    "Escambia",
	"Flagler",
	"Franklin",
	"Gadsden",
	"Gilchrist",
	"Glades",
	"Gulf",
	"Hamilton",
	"Hardee",
	"Hendry",
	"Hernando",
	"Highlands",
	"Hillsborough",
    "Holmes",
	"Indian River",
	"Jackson",
	"Jefferson",
	"Lake",
	"Lafayette",
	"Lee",
	"Leon",
	"Levy",
	"Liberty",
	"Madison",
	"Manatee",
	"Marion",
	"Martin",
	"Miami-Dade",
	"Monroe",
	"Nassau",
	"Okaloosa",
	"Okeechobee",
	"Orange",
	"Osceola",
	"Palm Beach",
	"Pasco",
	"Pinellas",
	"Polk",
	"Putnam",
	"Santa Rosa",
	"Sarasota",
	"Seminole",
	"St. Johns",
	"St. Lucie",
	"Sumter",
	"Suwannee",
	"Taylor",
	"Union",
	"Volusia",
	"Wakulla",
	"Walton",
	"Statewide & National",
	"Central Florida (Osceola, Highlands, Hardee, Polk, Seminole, Orange, Lake, Sumter, Marion)",
];

const table = new Map();
const Alachua = [33615, 32653, 32643, 32616];
Alachua.map((code) => {
    table.set(code, "Alachua");
});
const Baker = [32040, 32234, 32063, 32072, 32087];
Baker.map((code) => {
    table.set(code, "Baker");
});
const Bay = [32401, 32403, 32404, 32405, 32407];
Bay.map((code) => {
    table.set(code, "Bay");
});
const Bradford = [32622, 32044, 32656, 32054, 32058, 32666, 32083, 32026, 32091];
Bradford.map((code) => {
    table.set(code, "Bradford");
});


export function matchToCounty(curZipCodes, curCounties) {
	// Put counties for current zipcodes
    const counties = [];
    curZipCodes.map((code) => {
        counties.push(table.get(code));
    });

	//if there are no zipcodes for the current counties
	var check = false;
	curCounties.map((county) => {
		
	})

	return counties;
}
